// extracted by mini-css-extract-plugin
export default {"badge":"CorporateAlert-badge_m8XLb"};